import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectMenuOpen, setMenuOpen } from '@shared/store/general.duck';
import { Link, useLocation } from "react-router-dom";
import styled from 'styled-components';
import Icon, { IconTypes } from "../../../../atoms/icon/Icon";
import { BodyVerySmall } from "../../../../atoms/fonts/Body";
import { CurrentUserAvatarAndName } from "../../../../molecules/UserAvatarAndName";
import DropDownList from "../drop-down-list/DropDownList";
import './user-menu.scss';
import Colours from "../../../../atoms/Colours";
import { VerticallyCenteredRow } from '../../../../atoms/StructuralLayout';
import NotificationCounter from '../NotificationCounter';
import { useTranslation } from "react-i18next";

export default function UserMenu() {
  const location = useLocation();
  const dispatch = useDispatch();
  const isMenuOpen = useSelector(selectMenuOpen);
  const [isAvatarMenuOpen, setIsAvatarMenuOpen] = useState(false);
  const {t} = useTranslation();

  const open = () => dispatch(setMenuOpen(!isMenuOpen));
  const toggleAvatarMenu = () => setIsAvatarMenuOpen(prev => !prev);
  const closeAvatarMenu = () => setIsAvatarMenuOpen(false);
  const onLogout = () => {
    closeAvatarMenu();
    localStorage.clear();
    window.location.href = '/login';
  };

  return (
    <>

      {isMenuOpen ? <div className="userMenu__closeContainer" onClick={() => dispatch(setMenuOpen(false))}/> : null}
      {isAvatarMenuOpen ? <div className="userMenu__closeContainer" onClick={closeAvatarMenu}/> : null}
      <nav className={`row navigation userMenu`}>
        <div className={`userMenu__item userMenu__manage ${location.pathname.includes('/manage') ? 'userMenu__manage--selected' : ''}`.trim()}>
          <Link to="/manage" data-test="userMenu-manage-link" className="noDecoration">
            <VerticallyCenteredRow>
              <Icon className="userMenu__icon" icon={IconTypes.Settings} color="white"/>
              <BodyVerySmall weight={600} colour={Colours.white} className="userMenu__label">{t('settings.settings')}</BodyVerySmall>
            </VerticallyCenteredRow>
          </Link>
        </div>

        <AvatarMenuContainer>
          <NotificationCounter count={0}>
            <AvatarClickable data-test="userMenu-avatar-button" onClick={toggleAvatarMenu}>
              <CurrentUserAvatarAndName hideName={true} colour="blue" />
            </AvatarClickable>
          </NotificationCounter>
          {isAvatarMenuOpen && (
            <AvatarDropdown>
              <AvatarDropdownItem data-test="userMenu-logout-button" onClick={onLogout}>
                {t('button.logout')}
              </AvatarDropdownItem>
            </AvatarDropdown>
          )}
        </AvatarMenuContainer>

        <div className={isMenuOpen ? 'userMenu__dropdown--open' : ''}>
          <Icon className="userMenu__dropDownButton"
                icon={isMenuOpen ? IconTypes.Close : IconTypes.Menu}
                color={'white'}
                onClick={open} />
          <DropDownList/>
        </div>
      </nav>
    </>
  )
}

const AvatarMenuContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const AvatarClickable = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const AvatarDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background-color: #ffffff;
  border: 1px solid #BCC6C7;
  border-radius: 8px;
  box-shadow: 0 20px 34px rgba(145, 155, 173, 0.15);
  min-width: 160px;
  z-index: 1001;
  overflow: hidden;
`;

const AvatarDropdownItem = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family: "soleil", sans-serif;
  font-size: 14px;
  color: ${Colours.darkGrey};
  &:hover {
    background-color: rgba(1, 1, 1, .05);
  }
`;
